module.exports = __webpack_public_path__ + "static/torn-bg-white-t-3b8f14a022f38ccadbd56e91f7f2238b.png";